import { mallTradeApi } from '../request'
import { apiPath } from '../api'

export const cancelOrder = {
  cancelOrderInfo: data => mallTradeApi.post(apiPath.CancelAjax, data),
  submitCancelOrder: data => mallTradeApi.post(apiPath.doCancel, data)
}
